<template>
  <div class="category-articles">
    <h1>{{ category.name }}</h1>
    <h2 v-for="({ slug, title }, idx) in category.articles" :key="idx" class="title">
      <nuxt-link :to="`/support/${slug}/`">
        {{ title }}
      </nuxt-link>
    </h2>
  </div>
</template>

<script>

export default {
  props: {
    category: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
.category-articles {
  .title {
    font-size: inherit;
    line-height: 150%;

    &:not(:last-child) {
      margin-bottom: var(--spacing-md);
    }

    a {
      color: var(--accent-shade-2);
      font-weight: 500;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
